import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/auth'

const config =
  process.env.NODE_ENV === 'production'
    ? {
        apiKey: 'AIzaSyD_GJKBb-JtR5_B-8oXDXSMHr85fut4nkM',
        authDomain: 'pomodone-prod.firebaseapp.com',
        databaseURL: 'https://pomodone-prod.firebaseio.com',
        projectId: 'pomodone-prod',
        storageBucket: 'pomodone-prod.appspot.com',
        messagingSenderId: '348657909151',
        appId: '1:348657909151:web:1e793b556378fc9c4251aa',
      }
    : {
        apiKey: 'AIzaSyAM5VyftOIehntxsZPhoAwvQXDK6rxPZOc',
        authDomain: 'pomodone-dev.firebaseapp.com',
        databaseURL: 'https://pomodone-dev.firebaseio.com',
        projectId: 'pomodone-dev',
        storageBucket: 'pomodone-dev.appspot.com',
        messagingSenderId: '324157996308',
        appId: '1:324157996308:web:c20e568aa75a40ff1e9601',
      }

firebase.initializeApp(config)

export default firebase
